<template>
  <div class="flex justify-center">
    <div class="flex flex-column justify-center">
      <div>
        <img class="w-400" src="@/assets/img/404.svg">
      </div>
      <div class="content">
        <h1 class="flex justify-center">404</h1>
        <div class="desc flex justify-center">抱歉，你访问的页面不存在或仍在开发中</div>
        <div class="action flex justify-center">
          <el-button type="primary" @click="backHome">返回首页</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "E404",
  methods: {
    backHome() {
      this.$router.push("/index")
    }
  }
}
</script>

<style scoped>

.content h1{
  color: #434e59;
  font-size: 72px;
  font-weight: 600;
  line-height: 72px;
  margin-bottom: 24px;
}
.content .desc{
  color: #91ACFF;
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 16px;
}
</style>
